import { BaseApi } from '../base';
import { TNotification, NotificationType } from '../../types/notification';

export interface GetNotificationsParams {
  page?: number;
  pageSize?: number;
  userId?: string;
  isRead?: boolean;
  notificationType?: NotificationType;
}

export interface PaginatedNotifications {
  items: TNotification[];
  meta: {
    totalItems: number;
    itemCount: number;
    itemsPerPage: number;
    totalPages: number;
    currentPage: number;
  };
}

class NotificationsAPI extends BaseApi {
  async getNotifications(
    params: GetNotificationsParams = {}
  ): Promise<PaginatedNotifications> {
    const response = await this.get('/notifications', { params });
    return response.data;
  }

  async getUnreadCount(userId: string): Promise<number> {
    const response = await this.get('/notifications/unread-count', {
      params: { userId },
    });
    return response.data;
  }

  async markAsRead(notificationId: string): Promise<TNotification> {
    const response = await this.post(`/notifications/${notificationId}/read`);
    return response.data;
  }

  async markAllAsRead(userId: string): Promise<void> {
    await this.post('/notifications/mark-all-read', { userId });
  }

  async deleteNotification(notificationId: string): Promise<void> {
    await this.delete(`/notifications/${notificationId}`);
  }

  async resendNotification(notificationId: string): Promise<{
    success: boolean;
    message: string;
    notification?: {
      id: string;
      type: string;
      recipient: {
        email: string;
        name: string;
        role: string;
      };
    };
  }> {
    const response = await this.post(`/notifications/${notificationId}/resend`);
    return response.data;
  }

  async sendManualMessage(data: {
    subject: string;
    body: string;
    recipientIds: string[];
    sendMode?: 'individual' | 'group';
  }): Promise<{
    success: boolean;
    message: string;
    sent: number;
    total: number;
  }> {
    const response = await this.post('/notifications/send-manual', data);
    return response.data;
  }

  async sendAvailabilityReminder(staffIds?: string[]): Promise<{
    success: boolean;
    message: string;
  }> {
    const response = await this.post('/notifications/send-availability-reminder', {
      staffIds,
    });
    return response.data;
  }
}

export const notificationsAPI = new NotificationsAPI();
